import axios from "axios";
import "./localstorage.js";
// import env from '../config/env';
import host from "../config/host";
import { util_api } from "./util_api";

import { arrObjToHash as _arrObjToHash } from "./data_handler_util";
import Http from "./http";
import Vue from "vue";

let util = {
  moment: window.moment,
  urls: {
    query_customer_name: "customer/query_name",
    get_my_informal_path: "informal/my_informal",
  },
};
util.title = function (title) {
  title = title ? title + " - Home" : "iView project";
  window.document.title = title;
};
util.checkRouteAuthTimer = -1;
util.checkRouteAuth = (to) => {
  if (eventHub._events["check-route-auth"]) {
    eventHub.$emit("check-route-auth", to);
  } else {
    clearTimeout(util.checkRouteAuthTimer);
    util.checkRouteAuthTimer = setTimeout(() => {
      util.checkRouteAuth(to);
    }, 500);
  }
};
util.downloadToBlank = (obj = {}, url = util_api.download_attachment) => {
  let params = [];
  Object.keys(obj).forEach((k) => {
    if (obj[k] !== undefined) {
      params.push(`${k}=${obj[k]}`);
    }
  });
  return window.open(`/api/${url}?${params.join("&")}`, "_blank");
};
const staticUrl = process.env.NODE_ENV !== "production" ? host.dev : host.prod;
export const hrUrl = (util.hrUrl = `${host.hr}/api`);
export const ajaxUrl =
  process.env.NODE_ENV !== "production"
    ? `${host.dev}/api`
    : `${host.prod}/api`;
export const authUrl =
  process.env.NODE_ENV !== "production"
    ? `${host.dev}/api`
    : `${host.auth}/api`;
export const pay_manage_url = `${host.pay_manage}/api`;
export const spider_url = `https://cya-spider.baicizhan.com`
util.websocket_host = staticUrl.replace("https", "wss").replace("http", "ws");
const ajaxParams = {
  baseURL: ajaxUrl,
  transformResponse: [
    (data) => {
      const prod_login_url = `https://hr.baicizhan-people.com/login?service=${location.href}`;
      if (data.indexOf("需要登录才能继续访问") > -1) {
        window.location.href = prod_login_url;
        return { code: 0, msg: "登录过期, 请重新登录" };
      }
      try {
        data = JSON.parse(data);
        // need login
        if (data.code === -1) {
          if (data.env === "development") {
            window.eventHub.$emit("show-dev-login");
          } else {
            window.location.href = prod_login_url;
            return { code: 0, msg: "登录过期, 请重新登录" };
          }
        }
      } catch (e) {
        console.log(e);
      }
      return data;
    },
  ],
  withCredentials: true,
  timeout: 300000,
};
export const http = (util.http = new Http({
  host: ajaxParams.baseURL,
  contentKey: "data",
  ...ajaxParams,
}));
export const hr_http = (util.hr_http = new Http({
  host: hrUrl,
  contentKey: "data",
  ...ajaxParams,
  baseURL: hrUrl,
  data_code: 0,
}));
export const spider_http = (util.spider_url = new Http({
  host: spider_url,
  contentKey: "data",
  ...ajaxParams,
  baseURL: spider_url,
  data_code: 0,
}))

export const pay_manage_http = (util.pay_manage_http = new Http({
  host: pay_manage_url,
  contentKey: "data",
  ...ajaxParams,
  baseURL: pay_manage_url,
}));

export const pay_manage_http_upload = new Http({
  host: pay_manage_url,
  contentKey: "data",
  ...ajaxParams,
  baseURL: pay_manage_url,
  timeout: 3000000,
});
export const ajax = (util.ajax = axios.create(ajaxParams));
export const ajax_download = axios.create({
  ...ajaxParams,
  responseType: "arraybuffer",
  transformResponse: [(data) => data],
});
export const api = (util.api = util_api);

util.kind_editor_root_path = staticUrl + "/assets/kindeditor/";
util.kind_editor_upload_path = ajaxUrl + "/upload_kind_editor_file";

util.title = function (title) {
  title = title ? title + " - MIS" : "MIS SYSTEM";
  window.document.title = title;
};
util.clone = function (obj) {
  let o;
  if (typeof obj === "object") {
    if (obj === null) {
      o = null;
    } else {
      if (obj instanceof Array) {
        o = [];
        for (let i = 0, len = obj.length; i < len; i++) {
          o.push(util.clone(obj[i]));
        }
      } else {
        o = {};
        for (let k in obj) {
          o[k] = util.clone(obj[k]);
        }
      }
    }
  } else {
    o = obj;
  }
  return o;
};
util.blength = (string) => {
  return string.toString().blength();
};
util.insertOrUpdateArrayItem = (array, item, is_unshift) => {
  let len = array.length;
  let exsit = false;
  let cur;
  let index = -1;
  for (let i = 0; i < len; i++) {
    cur = array[i];
    if (cur.id === item.id) {
      Object.assign(cur, item);
      exsit = true;
      index = i;
      break;
    }
  }
  if (!exsit) {
    if (is_unshift) {
      array.unshift(item);
    } else {
      array.push(item);
    }
  }
};
util.moveUpArrayItemByIndex = (array, index) => {
  if (index === 0) {
    alert("已经是第一个元素了!");
    return;
  }
  let tmp = array[index];
  array.splice(index, 1);
  array.splice(index - 1, 0, tmp);
};
util.moveDownArrayItemByIndex = (array, index) => {
  if (index === array.length - 1) {
    alert("已经是最后一个元素了!");
    return;
  }
  let tmp = array[index];
  array.splice(index, 1);
  array.splice(index + 1, 0, tmp);
};
util.removeArrayItemByIndex = (array, index) => {
  return array.splice(index, 1);
};
util.removeArrayItem = (array, item) => {
  let len = array.length;
  let cur;
  for (let i = 0; i < len; i++) {
    cur = array[i];
    if (cur.hasOwnProperty("id") && item.hasOwnProperty("id")) {
      if (cur.id === item.id) {
        array.splice(i, 1);
        break;
      }
    } else {
      if (cur === item) {
        array.splice(i, 1);
        break;
      }
    }
  }
};
util.isArrayItem = (array, item) => {
  let len = array.length;
  for (let i = 0; i < len; i++) {
    let cur = array[i];
    if (cur.id === item.id) {
      return true;
    }
  }
  return false;
};

util.isObject = function (obj) {
  return typeof obj === "object" && obj !== null && !(obj instanceof Array);
};
util.isNumber = (str) => {
  let reg = /^(-?\d+)(\.\d+)?$/;
  return reg.test(str);
};
util.getMaxZIndex = function () {
  const nodes = document.querySelectorAll("body *");
  const arr = [];
  nodes.forEach((node) => {
    const idx = node.style.zIndex;
    if (idx && parseInt(idx) < 9999999) arr.push(parseInt(idx));
  });
  arr.sort((a, b) => {
    return b - a;
  });
  return arr.length ? arr[0] : 1000;
};
util.urlEncode = function (param, key, encode) {
  if (!param && !key) return "";
  let paramStr = "";
  let t = typeof param;
  if (t === "string" || t === "number" || t === "boolean") {
    paramStr +=
      "&" +
      key +
      "=" +
      (encode === null || encode ? encodeURIComponent(param) : param);
  } else {
    for (let i in param) {
      //let k = !key ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i);
      let k = !key ? i : key + (param instanceof Array ? "[]" : "." + i);
      paramStr += util.urlEncode(param[i], k, encode);
    }
  }
  return paramStr;
};

util.extname = (filename) => {
  let name_split = filename.split(".");
  if (name_split.length === 1) {
    return "";
  } else {
    return `.${name_split[name_split.length - 1]}`;
  }
};

//员工头像
util.avatarUrl = (avatar_name) => {
  return `${staticUrl}/uploads/avatar/${avatar_name}`;
};
//用户其他文件
util.customerFileUrl = (filename) => {
  return `${staticUrl}/uploads/customer_files/${filename}`;
};
util.staticFile = (filename) => {
  return `${staticUrl}/static/${filename}`;
};
// 回单文件
util.receiptUrl = (filename) => {
  return `${staticUrl}/static/receipts/${filename}`;
};

const OSS_PUBLIC_HOST = `https://${
  process.env.NODE_ENV !== "production" ? "bczmis-public-dev" : "bczmis-public"
}.oss-cn-hangzhou.aliyuncs.com`;
//public oss 附件
util.publicAttachmentUrl = (file) => {
  return `${OSS_PUBLIC_HOST}/attachment/${file.customer_id}/${
    file.md5
  }${util.extname(file.name)}`;
};
//public oss 文件
util.publicOSSUrl = (filepath) => {
  return `${OSS_PUBLIC_HOST}/${filepath}`;
};
//mall image url
util.mallFileUrl = (path) => {
  return `https://fulfillment.bczcdn.com/rc201603281546${path}`;
};
// download file
util.forceDownload = (url, filename = "") => {
  if (!filename) {
    const split_arr = url.split("/");
    filename = split_arr[split_arr.length - 1];
  }
  const xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.responseType = "blob";
  xhr.onload = function () {
    const urlCreator = window.URL || window.webkitURL;
    const imageUrl = urlCreator.createObjectURL(this.response);
    const tag = document.createElement("a");
    tag.href = imageUrl;
    tag.download = filename;
    document.body.appendChild(tag);
    tag.click();
    document.body.removeChild(tag);
  };
  xhr.send();
};

// 邮箱格式检查
util.emailCheck = (email) => {
  let email_reg =
    /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  return email_reg.test(email);
};
// 手机号检查
util.mobileCheck = (mobile) => {
  let reg = /^1[0-9]{10}$/;
  return reg.test(mobile);
};
// 银行卡格式检查, 某些银行卡不符合此校验规则
util.LuhnCheck = (card_number) => {
  card_number = card_number.toString();
  if (!/^[0-9]*$/.test(card_number)) {
    return false;
  }
  let nums = card_number.split("").reverse();
  let odd_sum = 0;
  let even_sum = 0;
  nums.forEach((num, i) => {
    if ((i + 1) % 2) {
      odd_sum += num * 1;
    } else {
      num = num * 2;
      num = num > 9 ? num - 9 : num;
      even_sum += num;
    }
  });
  let sum = odd_sum + even_sum;
  return !(sum % 10);
};
// 身份证校验
util.IDCheck = (id_number) => {
  if (id_number && id_number.length === 18) {
    let nums = id_number.split("");
    let weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    let sum = 0;
    weights.forEach(function (weight, index) {
      sum += weight * nums[index];
    });
    let checkNum = 12 - (sum % 11);
    if (checkNum === 10) {
      checkNum = "X";
    } else if (checkNum > 10) {
      checkNum = checkNum - 11;
    }
    console.log("check num: " + checkNum);
    return checkNum.toString() === nums[17].toUpperCase();
  } else {
    return false;
  }
};

util.threeCheckStatusName = (status) => {
  let name = "";
  switch (status) {
    case 0:
      name = "未通过";
      break;
    case 1:
      name = "通过";
      break;
    case 2:
      name = "通过(支付宝仅验证姓名与身份证)";
      break;
    case 3:
      name = "尚未核验";
      break;
    default:
      name = "未定义三要素验证状态";
  }
  return name;
};

util.formatPrice = (price_str, digits = 2) => {
  return price_str
    ? math
        .eval(price_str)
        .toFixed(digits)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,")
    : "0.00";
};
util.formatDecimal = util.formatPrice;
util.formatNumber = (num_str) => {
  return num_str
    ? math
        .eval(num_str)
        .toFixed(0)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    : "0";
};
util.formatMonth = (date) => {
  return moment(date).format("YYYY-MM");
};
util.formatDate = (date) => {
  return moment(date).format("YYYY-MM-DD");
};
util.formatTime = (time) => {
  return moment(time).format("YYYY-MM-DD HH:mm:ss");
};
util.fromNow = (date_str) => {
  let date = new Date(date_str);
  let now = new Date();
  if (now.getTime() > date.getTime() + 3 * 24 * 3600 * 1000) {
    return moment(date).format("YYYY-MM-DD HH:mm:ss");
  }
  return moment(date).fromNow();
};
util.curMonth = () => {
  let now = moment();
  let year = now.year();
  let month = now.month() + 1;
  if (this.type === "monthly") {
    if (month === 1) {
      year = year - 1;
      month = 12;
    } else {
      month = month - 1;
    }
  }
  if (month < 10) {
    month = `0${month}`;
  }
  return `${year}-${month}`;
};

let enNum2CnNum = {
  0: "零",
  1: "壹",
  2: "贰",
  3: "叁",
  4: "肆",
  5: "伍",
  6: "陆",
  7: "柒",
  8: "捌",
  9: "玖",
};

util.offlineOrderSendShop = (value) => {
  let name = "";
  switch (value) {
    case 21:
      name = "推广店铺";
      break;
    case 22:
      name = "运营店铺";
      break;
    case 23:
      name = "福利店铺";
      break;
    case 24:
      name = "赠送店铺";
      break;
    case 25:
      name = "内购店铺";
      break;
    case 26:
      name = "公司自用店铺";
      break;
    case 27:
      name = "其他店铺";
      break;
    case 65:
      name = "分销店铺";
      break;
    default:
      name = "错误店铺";
  }
  return name;
};
util.offlineOrderSendUsage = (value) => {
  let name = "";
  switch (value) {
    case 21:
      name = "推广";
      break;
    case 22:
      name = "运营";
      break;
    case 23:
      name = "福利";
      break;
    case 24:
      name = "赠送";
      break;
    case 25:
      name = "内购";
      break;
    case 26:
      name = "公司自用";
      break;
    case 27:
      name = "其他";
      break;
    case 65:
      name = "分销";
      break;
    default:
      name = "错误信息";
  }
  return name;
};

export function containHeight() {
  return this.$store.state.window_height - 180;
}

util.getChineseNum = (num) => {
  let ret = enNum2CnNum[num];
  if (ret) {
    return ret;
  } else {
    throw "undefined number:" + num;
  }
};
util.guid = () => {
  return "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx".replace(/x/g, function (c) {
    let r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
util.globalModalContain = new Vue();
export const formattingNumber = (util.formattingNumber = function (
  number,
  digit = 0,
  unit = 1
) {
  var regex = /\B(?=(\d{3})+\b)/g;
  const _number = number;
  number = Number(number) / unit;
  let point = number % 1;
  point = point.toFixed(digit);
  if (point.indexOf(".") !== -1) {
    point = point.slice(point.indexOf("."));
  } else {
    point = "";
  }
  number = parseInt(number).toString();
  if (_number < 0 && _number > -1) {
    return `-${number.replace(regex, ",") + point}`;
  }
  return number.replace(regex, ",") + point;
});
export const arrObjToHash = (util.arrObjToHash = _arrObjToHash);

export const getsafe = (target, key_str, s = null) => {
  if ([null, undefined].includes(key_str)) {
    return s;
  }
  const keys = key_str.split(".");
  if (!target || !keys.length) {
    return s;
  }
  return keys.reduce((total, key) => {
    if (!total) {
      return s;
    }
    return total[key];
  }, target);
};

export const isNUE = (target) => {
  return [null, undefined, ""].includes(target);
};

window.Util = util;

export const is_prod = host.is_prod;
export default util;
